// extracted by mini-css-extract-plugin
export var smallSpinner = "_s1-0";